import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// Treat optional trailing slashes as the same SPA route.
export function normalizeRoutePath(path) {
  if (typeof path !== 'string') {
    return '/';
  }
  return path.replace(/\/+$/, '') || '/';
}

const routes = [
    {
        path: '/',
        name: 'SponsorForm',
        component: () => import('@/views/SponsorForm.vue')
    },
    {
        path: '/checkout',
        name: 'Checkout',
        meta: { hideHeader: true },
        component: () => import('@/views/Checkout.vue')
    },
    {
        path: '/checkout/success',
        name: 'CheckoutSuccess',
        meta: { hideHeader: true },
        component: () => import('@/views/CheckoutSuccess.vue')
    },
    {
        path: '/checkout/subscription',
        name: 'CheckoutSubscription',
        meta: { hideHeader: true },
        component: () => import('@/views/CheckoutSubscription.vue')
    },
    {
        path: '/checkout/cryptopayment',
        name: 'CheckoutCryptoPayment',
        meta: { hideHeader: true },
        component: () => import('@/views/CheckoutCryptoPayment.vue')
    },
    {
        path: '/wall',
        meta: { hideHeader: true },
        component: () => import('@/new/layouts/WallLayout.vue'),
        children: [
            { path: '', redirect: 'home' },
            { path: 'home', name: 'WallHome', component: () => import('@/new/views/wall/Home.vue') },
            { path: 'effects', name: 'WallEffects', component: () => import('@/new/views/wall/Effects.vue') },
            { path: 'cryptopayment', name: 'WallCryptoPayment', component: () => import('@/new/views/wall/CryptoPayment.vue') },
            { path: 'subscription/cryptopayment', name: 'WallSubscriptionCryptoPayment', component: () => import('@/new/views/wall/SubscriptionCrypto.vue') },
            { path: 'subscription', name: 'WallSubscription', component: () => import('@/new/views/wall/Subscription.vue') },
            { path: 'gift/:token', name: 'WallGiftRedeem', component: () => import('@/new/views/wall/GiftRedeem.vue') },
            { path: 'about', name: 'WallAbout', component: () => import('@/new/views/wall/About.vue') },
            { path: 'success', name: 'WallSuccess', component: () => import('@/new/views/wall/Success.vue') },
            { path: 'sent', name: 'WallSent', component: () => import('@/new/views/wall/Sent.vue') },
            { path: 'sent-donation', name: 'WallSentDonation', component: () => import('@/new/views/wall/Sent.vue') },
            { path: 'generate', name: 'WallGenerate', component: () => import('@/new/views/wall/Generate.vue') },
            { path: 'not-found', name: 'WallNotFound', component: () => import('@/new/views/wall/NotFound.vue') },
        ],
    },
    {
        path: '/gift/:token',
        name: 'GiftRedeem',
        redirect: (to) => ({ path: `/wall/gift/${encodeURIComponent(to.params.token)}`, query: to.query })
    },
    {
        path: '/success',
        name: 'PaymentSuccess',
        component: () => import('@/views/PaymentSuccess.vue')
    },
    {
        path: '/sent',
        name: 'Sent',
        component: () => import('@/views/Sent.vue')
    },
    {
      path: '/sent-donation',
      name: 'SentDonationWithoutGeneratedEffect',
      component: () => import('@/views/Sent.vue')
    },
    {
        path: '/subscriptions',
        name: 'Subscriptions',
        component: () => import('@/views/Subscriptions.vue')
    },
    {
        path: '/subscriptions/select',
        name: 'SubscriptionsSelector',
        component: () => import('@/views/SubscriptionsSelector.vue')
    },
    {
        path: '/subscriptions/unsubscribe',
        name: 'Unsubscribe',
        component: () => import('@/views/Unsubscribe.vue')
    },
    {
      path: '/generate',
      name: 'Generate',
      component: () => import('@/views/EffectGeneration.vue')
    },
    {
        path: '*',
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue')
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});


// Redirect unknown routes to new 404 when new design is enabled
router.beforeEach((to, from, next) => {
  const frontendMode = (window.appConfig && window.appConfig.frontend_mode) || 'stream';
  const isCheckout = frontendMode === 'checkout';
  const routePath = normalizeRoutePath(to.path);
  if (isCheckout) {
    if (routePath === '/') {
      return next('/checkout');
    }
    if (!routePath.startsWith('/checkout')) {
      return next('/checkout');
    }
    return next();
  }
  const isNew = (window.appConfig && window.appConfig.new_design_enabled) || false;
    if (!isCheckout && routePath.startsWith('/checkout')) {
      return next(isNew ? '/wall/home' : '/');
    }
    if (isNew) {
      if (routePath === '/success') {
        return next('/wall/success');
      }
      if (routePath === '/sent') {
        return next('/wall/sent');
      }
      if (routePath === '/sent-donation') {
        return next('/wall/sent-donation');
      }
      if (routePath === '/generate') {
        return next({ path: '/wall/generate', query: to.query });
      }
      if (routePath === '/cryptopayment') {
        return next('/wall/cryptopayment');
      }
      if (routePath === '/subscription/cryptopayment') {
        return next('/wall/subscription/cryptopayment');
      }
      if (routePath === '/subscriptions/select' || routePath === '/subscriptions') {
        return next({ path: '/wall/subscription', query: to.query, hash: to.hash });
      }
    }
  if (isNew && to.matched.length === 0) {
    return next('/wall/not-found');
  }
  return next();
});

export default router;
